<ix-modal-header>
  {{ 'battery_pass.hierarchy.headline' | translate }}
</ix-modal-header>
<ix-modal-content>
  <ix-typography [format]="'body-lg'" class="mb-2">
    {{ 'battery_pass.hierarchy.connections_headline' | translate }}
  </ix-typography>
  <div class="d-flex align-items-start gap-2">
    <app-passport-search-select
      (itemClick)="onAddAncestor($event)"
      [disabled]="!!ancestor"
      [excludedPassports]="excludedPassports"
      [invalidText]="ancestorErrorMessage"
      [label]="'battery_pass.hierarchy.parent_passport_label' | translate"
      [value]="ancestor?.metadata?.name ?? ancestor?.id ?? ''"
      [type]="{child: true}"
      class="w-100">
    </app-passport-search-select>
    @if (!!ancestor) {
      <ix-icon-button (click)="onRemoveAncestor()"
        class="mb-1 delete-icon"
        icon="trashcan"
        onkeypress=""
        size="16"
        variant="subtle-primary"></ix-icon-button>
    }
  </div>
  <app-passport-search-select
    (itemClick)="onAddDescendant($event)"
    [excludedPassports]="excludedPassports"
    [invalidText]="descendantErrorMessage"
    [label]="'battery_pass.hierarchy.descendant_passport_label' | translate"
    [type]="{child: true}"
    class="w-100 ix-invalid">
  </app-passport-search-select>
  <div class="chip-wrapper">
    @for (descendant of descendants; track descendant) {
      <ix-chip
        (closeChip)="onRemoveDescendant(descendant)"
        [closable]="true"
        class="m-1"
        variant="neutral"
        >
        {{ descendant.metadata.name ?? descendant.id }}
      </ix-chip>
    }
  </div>
  <ix-typography [format]="'body-lg'" class="mt-3">
    {{ 'battery_pass.list.detail_hierarchy_table_header' | translate }}
  </ix-typography>
  @if (passport) {
    <app-hierarchy-graph
      [ancestor]="ancestor!"
      [descendants]="descendants"
      [passport]="passport">
    </app-hierarchy-graph>
  }
</ix-modal-content>
<ix-modal-footer>
  <ix-button
    (click)="activeModal.close(false)"
    class="dismiss-modal"
    id="workflowModalCancel"
    onkeypress=""
    variant="secondary">
    {{ 'general.cancel' | translate }}
  </ix-button>
  <ix-button
    [loading]="waitForSaving"
    (click)="onSaveHierarchy()"
    id="addIndividualButton"
    onkeypress=""
    variant="primary">
    {{ 'general.save' | translate }}
  </ix-button>
</ix-modal-footer>
